import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { BreadcrumbComponent, SidenavComponent } from "@ubisolutions/base/components";
import { ApplicationEventsService } from "@ubisolutions/base/events";
import { NavigationMenuComponent, SidebarComponent } from "@ubisolutions/core";
import { APP_NAVIGATION } from "@pages/app.navigation";
import { WORKSPACE_NAVIGATION } from "./workspace-home.navigation";
import {
    LanguageSelectorComponent,
} from "@shared/base/components/navigation/language-selector/language-selector.component";
import { AlertsMenuComponent } from "@shared/base/components/alerts/alerts/alerts-menu.component";
import { TopbarUserButtonComponent } from "@shared/base/components/topbar-user-button/topbar-user-button.component";

@Component({
    selector: "app-workspace-home",
    imports: [
        SidebarComponent,
        RouterOutlet,
        SidenavComponent,
        BreadcrumbComponent,
        NavigationMenuComponent,
        LanguageSelectorComponent,
        AlertsMenuComponent,
        TopbarUserButtonComponent,
    ],
    providers: [ApplicationEventsService],
    templateUrl: "./workspace-home.component.html",
    styleUrl: "./workspace-home.component.scss",
})
export class WorkspaceHomeComponent {
    protected readonly navigationData = WORKSPACE_NAVIGATION;
    protected readonly APP_NAVIGATION = APP_NAVIGATION;
}
